export const GET_CONTACT_ADDRESS_SUCCESS = 'GET_CONTACT_ADDRESS_SUCCESS';
export const GET_CONTACT_ADDRESS_FAIL = 'GET_CONTACT_ADDRESS_FAIL';